<template>
    <textarea
        class="p-3 text-dark border-solid border-2 border-grey-200 rounded w-full block focus:border-primary focus-visible:outline-none"
        :class="{'error': error}"
        :value="modelValue"
        @change="$emit('update:modelValue', $event.target.value)"
        ref="input"></textarea>
</template>

<script>
export default {
    props: ["modelValue", "error"],

    emits: ["update:modelValue"],

    methods: {
        focus() {
            this.$refs.input.focus();
        },
    },

    computed: {}
};
</script>

<style scoped>
.error {
    @apply border-danger;
}
</style>
